import { render, staticRenderFns } from "./AsientosLfpComponent.vue?vue&type=template&id=e058e0ea"
import script from "./AsientosLfpComponent.vue?vue&type=script&lang=js"
export * from "./AsientosLfpComponent.vue?vue&type=script&lang=js"
import style0 from "./AsientosLfpComponent.vue?vue&type=style&index=0&id=e058e0ea&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports